import { Box, Link as MUILink } from "@mui/material";
import React from "react";
import { InvocaPhone, useInvocaPhone } from "./useInvocaPhone";

const PHONE_ICON_URL =
  "https://cdn.builder.io/api/v1/image/assets%2Fc9fcfa3fdc8d44d2a2c2522da436aabc%2F13353a2ac884427b8cbb97b654a1c143?width=16";

const DEFAULT_FALLBACK_PHONE: InvocaPhone = {
  phoneRaw: "8772460106",
  phoneFormatted: "877-246-0106",
};

/**
 * Renders a phone icon and linked phone number fetched dynamically from
 * the Invoca ring-pool campaign API on mount.
 *
 * Falls back to `fallbackPhone` (or `DEFAULT_FALLBACK_PHONE` when no prop is
 * passed) while the API is loading or if it fails.
 */
export default function DynamicPhone({
  testIdPrefix = "",
  fallbackPhone = DEFAULT_FALLBACK_PHONE,
  hideIcon = false,
  color = "#303a52",
}: {
  testIdPrefix?: string;
  fallbackPhone?: InvocaPhone;
  hideIcon?: boolean;
  color?: string;
}) {
  const phone = useInvocaPhone();
  const displayPhone = phone ?? fallbackPhone;

  const linkTestId = testIdPrefix ? `${testIdPrefix}-phone-link` : undefined;
  const numberTestId = testIdPrefix
    ? `${testIdPrefix}-phone-number`
    : undefined;

  return (
    <Box sx={{ marginTop: "6px", cursor: "pointer", display: "flex" }}>
      {!hideIcon && (
        <MUILink href={`tel:${displayPhone.phoneRaw}`}>
          <Box
            component="img"
            alt="Phone Icon"
            src={PHONE_ICON_URL}
            width="16"
            height="20"
            style={{ marginTop: "2px", marginRight: "5px" }}
          />
        </MUILink>
      )}
      <MUILink
        {...(linkTestId && { "data-testid": linkTestId })}
        href={`tel:${displayPhone.phoneRaw}`}
        sx={{ textDecoration: "none", color }}
      >
        <Box {...(numberTestId && { "data-testid": numberTestId })}>
          {displayPhone.phoneFormatted}
        </Box>
      </MUILink>
    </Box>
  );
}
